module.exports = __webpack_public_path__ + "assets/img-placeholder.2ed01a92.svg";